interface OutletStatusBadgeProps {
  status: 'online' | 'offline' | 'degraded';
}

export function OutletStatusBadge({ status }: OutletStatusBadgeProps) {
  const styles = {
    online: 'bg-green-100 text-green-800 border-green-200',
    offline: 'bg-gray-100 text-gray-800 border-gray-200',
    degraded: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  };

  const labels = {
    online: 'Online',
    offline: 'Offline',
    degraded: 'Degraded',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles[status]}`}>
      <span className={`w-2 h-2 rounded-full mr-1.5 ${
        status === 'online' ? 'bg-green-500' :
        status === 'degraded' ? 'bg-yellow-500' :
        'bg-gray-500'
      }`} />
      {labels[status]}
    </span>
  );
}
